const config = {
    BASE_URL: 'https://app.leadssea.com:5006/api',
    // BASE_URL: 'http://192.168.0.104:5006/api',
    IMG_URL:'https://app.leadssea.com:5006',
  };
  
  export default config;
  